import { TextInput } from '@kcftech/design-system';
import { stringDefaultValueRules } from 'pages/Settings/AssemblyType/parameter_form/shared';
import {
    AssemblyParameterFormInputProps,
    typeGuardAssemblyParameterForm,
} from 'pages/Settings/AssemblyType/parameter_form/types';

export function AssemblyParameterTextFormContent({
    form: _form,
}: AssemblyParameterFormInputProps) {
    const form = typeGuardAssemblyParameterForm(_form, 'text');

    const {
        register,
        formState: { errors },
    } = form;

    return (
        <TextInput
            type="text"
            label="Default Value"
            placeholder="Enter a default value"
            error={errors.defaultValue?.message}
            {...register('defaultValue', stringDefaultValueRules)}
        />
    );
}
